import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn, MDBBtnGroup ,MDBIcon, MDBContainer} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import WarningBox from '../components/WarningBox';


import { toast, ToastContainer} from "mdbreact";



const AddEditOffice=(props)=>{

  const useMountEffect = (functionName) => useEffect(functionName, [])

  

       
  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [frm, setValues] = useState({
       code:'',
       description:'',
       acronym:'',
       active:true,
       usertoken: sessionStorage.getItem("msal.uc")

        
  });
  
  
     

  const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;
      
      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};

      

   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
         saveoffice();

  }
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


   

  const loadofficedetails=()=>
  {
    
    Axios.get(props.apiServer + '/loadofficedetails?acode=' + props.code ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
         
            setValues({ ...frm,
              code:props.code,
              description: res.data.description,
              acronym:  res.data.acronym,
              active:  res.data.active
              
            });   
                  
                  
        }
        else
        {
       
            console.log('No record');
        
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const saveoffice=()=> {
    
     const data =frm;
   
     Axios.post(props.apiServer + "/saveoffice", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
            setValues({...frm, code : res.data.code});
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
              props.refreshGrid();
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });
   
 }



 
 const deletePersonalInfo=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/delemp", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
        props.refreshEmployeesList();
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });

  
   
        
 }


 const [isAdmin,checkAdmin]=useState(0);

      
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
   
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }

useMountEffect(loadofficedetails);



    return (
        <React.Fragment>
        
           
            <MDBRow>
                <MDBCol md="10">
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     
                 
                   
                  

    
                    <MDBRow hidden>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.code} 
                            id="code"  
                            label="code" 
                            required
                            
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

         
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.description} 
                            id="description"  
                            label="Description" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

           
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.acronym} 
                            id="acronym"  
                            label="acronym" 
                          
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

                  
                    <MDBRow  >
                       <MDBCol md="12">
                       <MDBInput  
                      
                      
                      id="active" 
                      label="Is Active" 
                      type="checkbox"
                      checked={frm.active}
                      onChange={updateField}
                      
                     >
                      
                          <div className="invalid-feedback">
                          This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                      
                       </MDBCol>

                       
                      
                   </MDBRow>
                   <MDBRow>
                       <MDBCol md="6">
                       <MDBBtn className="blue lighten-1" type="submit">
                        Save
                    </MDBBtn>  {props.code==="" ?
                           (<MDBBtn id="cmdClose" className="blue lighten-4 blue-text"  onClick={props.toggleModal}>
                           Close
                       </MDBBtn>):(  
                       
                      ""
                    
                    )}
                       </MDBCol>
                       <MDBCol md="6">
                     
                       
                       </MDBCol>
                   </MDBRow>

                   
                  
                    </form>
                  
                </MDBCol>
            </MDBRow>
            
            <ToastContainer
            hideProgressBar={true}
            newestOnTop={true}
            autoClose={5000}/>

        
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditOffice
